import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-5" }
const _hoisted_6 = { class: "row mt-5" }
const _hoisted_7 = { class: "col-lg-4 mb-3" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">January</option><option value=\"2\">February</option><option value=\"3\">March</option><option value=\"4\">April</option><option value=\"5\">May</option><option value=\"6\">June</option><option value=\"7\">July</option><option value=\"8\">August</option><option value=\"9\">September</option><option value=\"10\">October</option><option value=\"11\">November</option><option value=\"12\">December</option>", 12)
const _hoisted_21 = { class: "col-lg-2 text-center mb-1" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " View ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_25 = { class: "col-lg-6" }
const _hoisted_26 = { class: "row col-lg-12" }
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_29 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-70px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-250px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Fullname"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Rank"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Non-GA Points")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_ECP_EDP_DashboardNavigator)
        ])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control form-control-lg form-control-solid mb-2",
                  placeholder: "year",
                  name: "year",
                  readonly: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.year = $event))
                }, null, 512), [
                  [_vModelText, _ctx.year]
                ])
              ]),
              _createVNode("div", _hoisted_8, [
                _withDirectives(_createVNode("select", {
                  class: "form-select form-select-solid form-select-lg fw-bold mb-2",
                  name: "month",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.month = $event))
                }, [
                  _hoisted_9
                ], 512), [
                  [_vModelSelect, _ctx.month]
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("button", {
                  type: "submit",
                  class: "btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getNonGATree_1()))
                }, [
                  _hoisted_22,
                  _hoisted_23
                ])
              ])
            ])
          ]),
          _hoisted_24,
          _createVNode("div", _hoisted_25, [
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_skeleton, {
                rows: 10,
                animated: ""
              })
            ], 512), [
              [_vShow, _ctx.loading]
            ]),
            _withDirectives(_createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("table", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", null, "      " + _toDisplayString(index + 1), 1),
                        _createVNode("td", null, _toDisplayString(item.usid.toUpperCase()), 1),
                        _createVNode("td", null, _toDisplayString(item.fullname.toUpperCase()), 1),
                        _createVNode("td", null, _toDisplayString(item.rank.toUpperCase()), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.trvPosPV.toFixed(4))), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ], 512), [
              [_vShow, !_ctx.loading]
            ])
          ])
        ])
      ]),
      _createVNode(_component_pagination, {
        pagination: _ctx.pagination,
        callback: _ctx.reorderhistory,
        options: _ctx.paginationOptions
      }, null, 8, ["pagination", "callback", "options"])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}